<template>
  <div>
    <v-switch
        style="width: 200px"
        class="mt-0"
        v-model="show_schedule"
        label="Agendar alteração"
    ></v-switch>

    <v-row no-gutters  v-if="show_schedule" class="blue-grey lighten-5 pl-4 pr-4 pt-4">
      <v-col :md="8" class="pr-2">
        <date-picker
          label="Data de início"
          no-icon
          outlined
          @change="changeStartDate"
        />
      </v-col>
      <v-col md="4" class="pl-2">
        <v-text-field
            label="Horário de início"
            @change="changeStartAt"
            type="time"
            outlined
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row no-gutters v-if="show_schedule" class="blue-grey lighten-5 pl-4 pr-4 pt-4">
      <v-col :md="8" class="pr-2">
        <date-picker
          label="Data de término"
          no-icon
          outlined
          @change="changeEndDate"
          :min="schedule_start"
        />
      </v-col>
      <v-col md="4" class="pl-2">
        <v-text-field
            label="Horário de término"
            @change="changeEndAt"
            type="time"
            outlined
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker'

export default {
  name: 'ScheduleForm',
  props: {
    small: Boolean
  },
  data: () => ({
    show_schedule: false,
    schedule_start: '',
    schedule_end: '',
    schedule_start_at: '',
    schedule_end_at: '',
    timeOptions: []
  }),
  components: {
    DatePicker
  },
  created() {
    this.timeOptions = this.generateOptions()
  },
  methods: {
    generateOptions() {
      const options = []
      for (let i = 0; i <= 24; i++) {
        options.push(`${i < 10 ? '0'+i : i}:00`)
        if (i < 24) options.push(`${i < 10 ? '0'+i : i}:30`)
      }
      return options
    },
    changeStartDate: function(date) {
      this.schedule_start = date
      this.$emit('change', {
        schedule_start: this.schedule_start,
        schedule_end: this.schedule_end,
        schedule_start_at: this.schedule_start_at,
        schedule_end_at: this.schedule_end_at,
      })
    },
    changeStartAt: function(hour) {
      this.schedule_start_at = hour
      this.$emit('change', {
        schedule_start: this.schedule_start,
        schedule_end: this.schedule_end,
        schedule_start_at: this.schedule_start_at,
        schedule_end_at: this.schedule_end_at,
      })
    },
    changeEndDate: function(date) {
      this.schedule_end = date
      this.$emit('change', {
        schedule_start: this.schedule_start,
        schedule_end: this.schedule_end,
        schedule_start_at: this.schedule_start_at,
        schedule_end_at: this.schedule_end_at,
      })
    },
    changeEndAt: function(hour) {
      this.schedule_end_at = hour
      this.$emit('change', {
        schedule_start: this.schedule_start,
        schedule_end: this.schedule_end,
        schedule_start_at: this.schedule_start_at,
        schedule_end_at: this.schedule_end_at,
      })
    },
  },
  watch: {
    show_schedule: function(val) {
      if (val === false) {
        this.schedule_start = ''
        this.schedule_start_at = '',
        this.schedule_end = '',
        this.schedule_end_at = ''
      }
    }
  }
}
</script>

<style scoped>
.border-rounded {
  border-radius: 10px;
}
</style>